import React, { Component } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TextField from '../../../common/TextField'
import { withStyles } from '@mui/styles'
import Button from '../../../common/Button'
import Grid from '@mui/material/Grid'
import { checkPrivileges } from '../../../../Helpers';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dense: {
    marginTop: 19
  },
  menu: {
    width: 200
  },
  button: {
    margin: theme.spacing(1)
  }
})

class termsAndConditions extends Component {
  constructor () {
    super()
    this.state = {
      errorMgs: false,
      form: {
        termsEnglishMaintenance: '',
        termsArabicMaintenance: '',
        termsEnglishLeasing: '',
        termsArabicLeasing: '',
        bankNameEnglish: '',
        bankHolderEnglish: '',
        accountNumberEnglish: '',
        ibanEnglish: '',
        bankNameArabic: '',
        bankHolderArabic: '',
        accountNumberArabic: '',
        ibanArabic: '',
      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.formSubmit = this.formSubmit.bind(this)

    this.checkRequiredFields = this.checkRequiredFields.bind(this)
  }
  getTermsRecord = (termsobj) =>
    termsobj?.data ||
    (termsobj?.id || termsobj?.attributes ? termsobj : null);

  getFormFromTerms = (termsobj) => {
    const record = this.getTermsRecord(termsobj);
    const attrs = record?.attributes || {};
    return {
      id: record?.id || 0,
      termsEnglishMaintenance: attrs.termsEnglishMaintenance || "",
      termsArabicMaintenance: attrs.termsArabicMaintenance || "",
      termsEnglishLeasing: attrs.termsEnglishLeasing || "",
      termsArabicLeasing: attrs.termsArabicLeasing || "",
      bankNameEnglish: attrs.bankNameEnglish || "",
      bankHolderEnglish: attrs.bankHolderEnglish || "",
      accountNumberEnglish: attrs.accountNumberEnglish || "",
      ibanEnglish: attrs.ibanEnglish || "",
      bankNameArabic: attrs.bankNameArabic || "",
      bankHolderArabic: attrs.bankHolderArabic || "",
      accountNumberArabic: attrs.accountNumberArabic || "",
      ibanArabic: attrs.ibanArabic || "",
    };
  };

  componentDidMount() {
    this.setState({
      form: this.getFormFromTerms(this.props.termsobj),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.termsobj !== this.props.termsobj) {
      this.setState({
        form: this.getFormFromTerms(this.props.termsobj),
      });
    }
  }

  formSubmit () {
    const { selectItemId } = this.props
    const termsRecord = this.getTermsRecord(this.props.termsobj);
    const accountId =
      selectItemId?.accountId ||
      this.props.selectedAccount?.id ||
      selectItemId;
      const payload = {
        id: termsRecord?.id || 0,
        property: termsRecord?.property || "terms",
        entityId: termsRecord?.entityId || accountId,
        description: termsRecord?.description || "description",
        ...termsRecord,
        attributes: { ...this.state.form },
      };
      fetch(`api/accounts/${accountId}/terms`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...payload,
        }),
        })
        .then((response) => {
          if (response.ok) {
            response.json().then((res) => {
              if (res.status === "success") {
                  toast.success(
                    "Changed",
                );
                const nextTerms = { data: res.data };
                this.setState({
                  form: this.getFormFromTerms(nextTerms),
                  errorMgs: false,
                });
                if (this.props.updateTermsObj) {
                  this.props.updateTermsObj(nextTerms);
                }
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                var err = res?.message.split(":");
                err[1] = err[1].replace(")", "");
              
                  toast.error(
                    this.props.translate(err[1]),
                );
              }
            });
          } else {
            throw response;
          }
        })
        .catch((e) => {
         
            toast.error(
             this.props.translate("somethingWentWrong"),
          );
        });
  }

  handleChange = name => event => {
    const { target } = event

    this.setState(
      {
        form: {
          ...this.state.form,
          [name]: target.value
        }
      }
    )
  }

  checkRequiredFields () {
    let { termsEnglish, termsArabic } = this.state.form
    if (termsEnglish.trim().length > 0 && termsArabic.trim().length > 0) {
     
        this.setState({
          errorMgs: false
        })
    
    } else {
      this.setState({
        errorMgs: true
      })
    }
  }
  

  render () {
    return (
      <div>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='english'
              label={this.props.translate('termsEnglishMaintenance')}
              type='text'
              placeholder=''
              error={this.state.nerrorMgs}
              value={this.state.form.termsEnglishMaintenance || ''}
              onChange={this.handleChange('termsEnglishMaintenance')}
              variant='outlined'
              margin='dense'
              fullWidth
              multiline={true}
              maxRows={30}
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='termsArabicMaintenance'
              error={this.state.errorMgs}
              label={this.props.translate('termsArabicMaintenance')}
              type='text'
              
              placeholder=''
              value={this.state.form.termsArabicMaintenance || ''}
              onChange={this.handleChange('termsArabicMaintenance')}
              variant='outlined'
              margin='dense'
              fullWidth
              multiline={true}
              maxRows={30}
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='termsEnglishLeasing'
              error={this.state.errorMgs}
              label={this.props.translate('termsEnglishLeasing')}
              type='text'
              
              placeholder=''
              value={this.state.form.termsEnglishLeasing || ''}
              onChange={this.handleChange('termsEnglishLeasing')}
              variant='outlined'
              margin='dense'
              fullWidth
              multiline={true}
              maxRows={30}
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='termsArabicLeasing'
              error={this.state.errorMgs}
              label={this.props.translate('termsArabicLeasing')}
              type='text'
              
              placeholder=''
              value={this.state.form.termsArabicLeasing || ''}
              onChange={this.handleChange('termsArabicLeasing')}
              variant='outlined'
              margin='dense'
              fullWidth
              multiline={true}
              maxRows={30}
            />
          </Grid>
        </Grid>
        <Grid container spacing={4} style={{marginTop:10}}>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='bankNameEnglish'
              label={this.props.translate('bankNameEnglish')}
              type='text'
              placeholder=''
              error={this.state.nerrorMgs}
              value={this.state.form.bankNameEnglish || ''}
              onChange={this.handleChange('bankNameEnglish')}
              variant='outlined'
              margin='dense'
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='bankHolderEnglish'
              error={this.state.errorMgs}
              label={this.props.translate('bankHolderEnglish')}
              type='text'
              
              placeholder=''
              value={this.state.form.bankHolderEnglish || ''}
              onChange={this.handleChange('bankHolderEnglish')}
              variant='outlined'
              margin='dense'
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='accountNumberEnglish'
              error={this.state.errorMgs}
              label={this.props.translate('accountNumberEnglish')}
              type='text'
              
              placeholder=''
              value={this.state.form.accountNumberEnglish || ''}
              onChange={this.handleChange('accountNumberEnglish')}
              variant='outlined'
              margin='dense'
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='ibanEnglish'
              error={this.state.errorMgs}
              label={this.props.translate('ibanEnglish')}
              type='text'
              
              placeholder=''
              value={this.state.form.ibanEnglish || ''}
              onChange={this.handleChange('ibanEnglish')}
              variant='outlined'
              margin='dense'
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='bankNameArabic'
              error={this.state.errorMgs}
              label={this.props.translate('bankNameArabic')}
              type='text'
              
              placeholder=''
              value={this.state.form.bankNameArabic || ''}
              onChange={this.handleChange('bankNameArabic')}
              variant='outlined'
              margin='dense'
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='bankHolderArabic'
              error={this.state.errorMgs}
              label={this.props.translate('bankHolderArabic')}
              type='text'
              
              placeholder=''
              value={this.state.form.bankHolderArabic || ''}
              onChange={this.handleChange('bankHolderArabic')}
              variant='outlined'
              margin='dense'
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='accountNumberArabic'
              error={this.state.errorMgs}
              label={this.props.translate('accountNumberArabic')}
              type='text'
              
              placeholder=''
              value={this.state.form.accountNumberArabic || ''}
              onChange={this.handleChange('accountNumberArabic')}
              variant='outlined'
              margin='dense'
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextField
              id='ibanArabic'
              error={this.state.errorMgs}
              label={this.props.translate('ibanArabic')}
              type='text'
              
              placeholder=''
              value={this.state.form.ibanArabic || ''}
              onChange={this.handleChange('ibanArabic')}
              variant='outlined'
              margin='dense'
              fullWidth
            />
          </Grid>
        </Grid>

        <br />
 {
  checkPrivileges("userUpdate")&&
  <Button
  variant='contained'
  style={{ marginLeft: 8 }}
  // disabled={!this.state.isVisableBtn}
  onClick={() => this.formSubmit()}
>
  {this.props.translate('sharedSave')}
</Button>
 }
     
      </div>
    )
  }
}
const TermsAndConditions = withStyles(styles)
export default TermsAndConditions(termsAndConditions)
